import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommunicationEventPurposeType, EditableStudentCommunicationEvent, StudentCommunicationEvent } from '../../model/student-communication-events';
import { MatTableDataSource } from '@angular/material/table';

import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { StudentCommunicationEventsService } from '../../service/student-communication-events.service';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { editPartyContactMechanismInterface } from 'src/app/component/party/edit-party-contact-mechanism/edit-party-contact-mechanism.component';
import { HelperService } from 'src/app/service/helper.service';
import { Region } from 'src/app/model/region.model';
import { CommunicationEventReportService } from 'src/app/component/child-reports/communication-event-report/service/communication-event-report.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { StudentHelperService } from '../../service/student-helper.service';

const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
    arr.reduce((groups, item) => {
        (groups[key(item)] ||= []).push(item);
        return groups;
    }, {} as Record<K, T[]>);

@Component({
    selector: 'app-communication-event',
    templateUrl: './communication-event.component.html',
    styleUrls: ['./communication-event.component.scss']
})
export class CommunicationEventComponent implements OnInit {
    @Input() studentId!: number;
    @Input() editing: boolean;

    lstStudentCommunicationEvent: EditableStudentCommunicationEvent[] = [];

    lstRegionbySCE: Array<any> = [];
    userRegion: Region;
    promises: Array<any> = [];
    boolFoundCommunicationEvents: boolean = true;
    addAccess: boolean = false;
    isLoading: boolean = true;
    studentName:string='';
    constructor(
        public studentHelperService: StudentHelperService,
        public communicationEventReportService: CommunicationEventReportService,
        public sces: StudentCommunicationEventsService,
        public loginTokenService: LoginTokenService,
        public helperService: HelperService,
        public accessService: AccessService
    ) {}

    ngOnInit(): void {

        this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName = studentName;
        });
        this.accessService.featureAccessible('Create Communication Events').subscribe((x) => {
            if (x) {
                this.addAccess = x;
            }
        });

        this.accessService.loadCommunicationEventPurposeType();
        this.getUserRegion();
        this.invokeApiGetStudentCommunicationEvents('');
    }

    ngOnChanges(): void {
        if (this.editing == false) this.invokeApiGetStudentCommunicationEvents('cancelled');
    }

    getUserRegion() {
        let deferred = new Promise((resolve, reject) => {
            this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
                this.userRegion = userRegion[0];

                resolve(this.userRegion);
            });
        });

        this.promises.push(deferred);
    }

    invokeApiGetStudentCommunicationEvents(action: string) {
        if (action == 'cancelled') {
            this.lstStudentCommunicationEvent = this.lstStudentCommunicationEvent.filter(
                (u: EditableStudentCommunicationEvent) => u.studentCommunicationEvent.ID !== -1
            );
            this.groupbyRegionCode();
        } else {
            this.sces.getStudentCommunicationEvents(this.studentId.toString()).subscribe((x) => {
                if (x['msg'] !== undefined) {
                    this.lstStudentCommunicationEvent = [];
                } else {
                    this.lstStudentCommunicationEvent = [];
                    let y: StudentCommunicationEvent[] = x['studentCommunicationEvents'];
                    y.forEach((element) => {
                        element.CREATED_DATE = new CleanDatePipe().transform(element.CREATED_DATE!);
                        element.MODIFIED_DATE = new CleanDatePipe().transform(element.MODIFIED_DATE!);
                        element.COMMUNICATION_DATE = new CleanDatePipe().transform(element.COMMUNICATION_DATE!);
                        this.lstStudentCommunicationEvent.push({ isEdit: false, studentCommunicationEvent: element, isDelete: false });
                    });
                    const now = new Date().getTime();

                    this.lstStudentCommunicationEvent.sort((a, b) => {
                        return (
                            (b.studentCommunicationEvent.COMMUNICATION_DATE ? b.studentCommunicationEvent.COMMUNICATION_DATE!.getTime() : now) -
                            (a.studentCommunicationEvent.COMMUNICATION_DATE ? a.studentCommunicationEvent.COMMUNICATION_DATE!.getTime() : now)
                        );
                    });
                }
                this.groupbyRegionCode();
            });
        }
    }

    groupbyRegionCode() {
        this.lstRegionbySCE = [];
        const record = groupBy(this.lstStudentCommunicationEvent, (i) => i.studentCommunicationEvent.REGION.CODE);
        Object.keys(record).map((key) => {
            let a: EditableStudentCommunicationEvent[] = record[key];
            this.lstRegionbySCE.push({ id: key, editableSCE: a });
        });

      this.boolFoundCommunicationEvents = this.lstRegionbySCE.length > 0 ? true : false;
      this.isLoading = false;
    }

    addRow() {
        if (this.editing) {
            this.lstStudentCommunicationEvent.findIndex((x) => x.isEdit == true) == -1
                ? (this.lstStudentCommunicationEvent = [
                      { isEdit: true, isDelete: false, studentCommunicationEvent: this.buildStudentCommunicationEvent() },
                      ...this.lstStudentCommunicationEvent
                  ])
                : null;
            this.groupbyRegionCode();
        }
    }

    buildStudentCommunicationEvent(): StudentCommunicationEvent {
        const arrPCMId = this.toNumberArray(this.lstStudentCommunicationEvent);
        let min = arrPCMId.length > 0 ? arrPCMId.reduce((a, b) => Math.min(a, b)) : 0;
        min = min > 0 ? -1 : min - 1;

        let tempSCE = new StudentCommunicationEvent();
        tempSCE.STUDENTS_ID = this.studentId;
        tempSCE.ID = min;
        tempSCE.COMMUNICATION_EVENT_PURPOSE_TYPES = new CommunicationEventPurposeType();
        tempSCE.STUDENT_COMMUNICATION_EVENT_PROPERTIES = [];
        tempSCE.REGION = this.userRegion;
        return tempSCE;
    }

    toNumberArray(array: EditableStudentCommunicationEvent[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.studentCommunicationEvent.ID ? returnArray.push(obj.studentCommunicationEvent.ID) : null;
        });

        return returnArray;
    }
}

/*
	createStudentService1() {
		this.dataSource.data.forEach((obj) => {
			if (obj.studentCommunicationEvent.ID < 0) {
				let requestPayload: any = {};
				requestPayload.studentCommunicationEvent = obj.studentCommunicationEvent;
				requestPayload.students = [this.student];
				this.sces.createStudentCommunicationEvents(requestPayload).subscribe(x => {
					console.log(x);
					let msg: Msg = x['msg'];
	
				});
			}
		});
		return true;
	}

	deleteStudentService1() {
		let templstDeleteSCE: StudentCommunicationEvent[] = [];

		this.lstDeleteSCommunicationEventId.forEach(x => {
			let a = this.lstStudentCommunicationEvent.find((element) => element.studentCommunicationEvent.ID == x);
			if (a) {
				templstDeleteSCE.push(a.studentCommunicationEvent)
			}
		});
		this.lstDeleteSCommunicationEventId = [];

		if (templstDeleteSCE.length > 0) {
			let requestPayload: any = {};
			requestPayload.studentCommunicationEvents = templstDeleteSCE;
			this.sces.deleteStudentCommunicationEvents(requestPayload).subscribe(x => {
				console.log(x);
				let msg: Msg = x['msg'];

			});
		}
		return true;

	}

	isDisabled() {
		if (this.dataSource.data.findIndex((x) => x.isEdit == true) == -1) {
			if (this.lstEditSCommunicationEventId?.length <= 0 && this.lstDeleteSCommunicationEventId?.length <= 0 && this.dataSource.data.findIndex((x) => x.studentCommunicationEvent.ID < 0) == -1)
				return true;
			else
				return false;
		}
		else
			return true;
	
	}
	*/
